/**
 * Collection card in-store availability.
 *
 * Shopify's `product.available` only counts shippable (eCommerce) locations, so
 * a product with 0 online inventory shows "Sold Out" on collection cards even
 * when physical stores have it in stock. This enhancer checks the dataconnect
 * stock (all locations) for the sold-out cards on the page and, when a product
 * is available in-store, flips the "Sold Out" pill to "Available in store".
 *
 * One batched API call per page (only for the sold-out cards).
 */
(function () {
  var API_BASE = 'https://shopify-manager-grc7a7fpbee0eqdx.canadaeast-01.azurewebsites.net';
  var processed = new WeakSet();

  function run() {
    var cards = Array.prototype.slice.call(
      document.querySelectorAll('.product-card[data-online-available="false"][data-card-variant-id]')
    ).filter(function (c) { return !processed.has(c) && c.dataset.cardVariantId; });
    if (!cards.length) return;

    cards.forEach(function (c) { processed.add(c); });

    var ids = [];
    cards.forEach(function (c) {
      if (ids.indexOf(c.dataset.cardVariantId) === -1) ids.push(c.dataset.cardVariantId);
    });
    if (!ids.length) return;

    fetch(API_BASE + '/products/api/stock-availability-batch/?variant_ids=' + encodeURIComponent(ids.join(',')))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.success || !data.variants) return;
        cards.forEach(function (card) {
          var info = data.variants[card.dataset.cardVariantId];
          if (info && info.available) markAvailableInStore(card);
        });
      })
      .catch(function () { /* leave the card as-is on error */ });
  }

  function markAvailableInStore(card) {
    // Flip the disabled "Sold Out" quick-add pill into an "Available in store"
    // label. It stays non-interactive — the card image/title already link to
    // the product page, which shows full store availability.
    var btn = card.querySelector('.quick-add button[disabled], .quick-add button.button--blur');
    if (btn) {
      btn.textContent = 'Available in store';
      btn.removeAttribute('disabled');
      btn.style.pointerEvents = 'none';
      btn.style.whiteSpace = 'nowrap';
      btn.classList.add('is-instore-available');
    }
    card.setAttribute('data-instore-available', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Re-check when the collection grid swaps in new cards (filters / pagination).
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('theme:collection:updated', run);
})();
